import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import { useFormikWizard } from "formik-wizard";
import 'setimmediate';
const fetch = require("node-fetch");
/**
 * 
 * @todos
 * - Error handling if service is do
 * - Error handling if no addresses found for a postcode
 * -- use the set state to determine if error or not
 */

 function naturalSort(a, b) {
  var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
      sre = /(^[ ]*|[ ]*$)/g,
      dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
      i = function(s) {
          return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s
      },
      // convert all to strings strip whitespace
      x = i(a).replace(sre, '') || '',
      y = i(b).replace(sre, '') || '',
      // chunk/tokenize
      xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      // numeric, hex or date detection
      xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
      yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
      oFxNcL, oFyNcL;
  // first try and sort Hex codes or Dates
  if (yD)
      if (xD < yD) return -1;
      else if (xD > yD) return 1;
  // natural sorting through split numeric strings and default strings
  for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
          return (isNaN(oFxNcL)) ? 1 : -1;
      }
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
          oFxNcL += '';
          oFyNcL += '';
      } 
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
  }
  return 0;
}

function BackToStart(){
  window.location.reload()
}



function AddressSelect() {

  const { errors, touched, handleBlur, handleChange } = useFormikContext();
  const { values } = useFormikWizard();
  const [addressResults, setaddressResults] = useState(0);
  const [AddressError, setAdressError] = useState(false)
  const [NoAddressesFound, setNoAddressesFound] = useState(false);
 
  useEffect(() => {
    
    fetch(`https://webapps.southglos.gov.uk/Webservices/SGC.RefuseCollectionService/RefuseCollectionService.svc/getAddresses/${values.postcode.postcode}`)
    .then((response) => {
        if(response.ok){
          return response.json();
        } else{
          setAdressError(true);
        }

      })
      .then((resultData) => {
        if(resultData && resultData.length > 0){
           let addressesSorted = [];
           for(let [key,value] of Object.entries(resultData)){
            addressesSorted.push({
              uprn: value.Uprn,
              address: value.Property + " " + value.Street + " " + value.Town,
            });
           };
           addressesSorted.sort(function(a,b){
            return naturalSort(a.address,b.address)
           })
          setaddressResults(addressesSorted);
        } else {
          setNoAddressesFound(true)
        }
      
      })
      
  }, []);

  return (
    <div>


      {AddressError  &&
      <>
        <h2>Addresses not found</h2>
        <p>We can't find addresses that match '{values.postcode.postcode}'. There was a problem fetching the data.</p>
        <a onClick={BackToStart}>Start again</a> or <a href="/contact">Contact us</a>
      </>
      }

      {NoAddressesFound && !AddressError && 
      <>
        <h2>Addresses not found</h2>
        <p>We can't find addresses that match '{values.postcode.postcode}'. This is either because the address is not in South Gloucestershire or is not in our database yet.</p>
        <a onClick={BackToStart}>Start again</a> or <a href="/contact">Contact us</a>
      </>
      }

        
      

      {!AddressError && !NoAddressesFound && 
      <>
        <h2>Select your address</h2>
        {values.postcode.postcode && 
        <div>
          <p><strong>{values.postcode.postcode}</strong> - <a onClick={BackToStart}>Change postcode</a></p>
        </div>
        }   
        {touched.addressSelect && errors.addressSelect &&  
          <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
           <ul role="presentation">
             <li>Address is a required field</li>
           </ul>
         </div>
         }

        <select
            name="addressSelect"
            onChange={handleChange}
            onBlur={handleBlur}
            //value={values.company.addressSelect}
          >
          <option value="">Select an address</option>
          {Object.entries(addressResults).map(([key, value]) => {
            return <option value={value["uprn"]}>{value["address"]}</option>;
          })}
        </select>
        <div className="form-footer mtop-20">  
          <button type="submit" className="button button--primary button__small">
            Continue
          </button>
      </div>
</>
      }

      
      
    </div>
  );
}

export default AddressSelect;
